;( function( $, undefined )
{
    $.fn.ComposeThread = function()
    {
        $( function()
        {
            if( location.href.indexOf( '?quote=true' ) != -1 )
            {
                $( '.quote-button' ).trigger( 'click' );

                setTimeout( function()
                {
                    if( undefined !== window.tinyMCE && undefined !== tinyMCE.activeEditor && !$( '[name="tinyMceEditor"]' ).is( ':visible' ) )
                    {
                        tinyMCE.activeEditor.setContent( tinyMCE.activeEditor.save() + '<p>&nbsp;</p>' )
                        content = tinyMCE.activeEditor.save();
                    }
                }, 500 );
            }
        } );

        // var $l10n = $( '#pm-l10n' )
        //   , $form = $( '.MessageEditor .lia-form-input-wrapper' );
        var $mainContainer        = $( '#PDC6-main-container' )
          , $threadComposePage    = $( '#thread-compose-page' )
          , $previewButton        = $( '.lia-link-navigation.preview-link' )
          , $previewClone         = $previewButton.clone().addClass( 'pdc6-button-black' )
          , $lithiumCategory      = $( '#lithium-choose-category' )
          , $availableCategories  = $( '#available-categories' )
          , $boardsList           = $( '#main-boards-list' )
          , $document             = $( document )
          , $currentCategory      = $( '#current-category' )
          , $subjectField         = $( '.lia-component-search-auto-complete-before-post' )
          , $currentSubject       = $( '.lia-form-subject-input' )
          , $currentLabelValue    = $( '#current-label-input' )
          , $currentBoardValue    = $( '#current-board-input' )
          , $lithiumComposeEditor = $( '#lithium-compose-editor' )
          , $errors               = $( '#compose-error' )
          , $labels               = $( '.labels' )
          , $labelsTabs           = $( '.CM090_inlineTabs_labels' )
          , $subjectLoader        = $( '#subject-inline-loader' )
          , $oldLabels            = $( 'input[name="labels"]' )
          , err                   = 'lia-form-field-error'
          , firstExec             = true
          , previewing            = false;

        $( function()
        {
            // temporary changing the number of emoticons since the page is taking ages to load
            try {
                //LITHIUM.TinyMceEditor.emoticonsHtml.html_original = LITHIUM.TinyMceEditor.emoticonsHtml.html;
                window.emoticons_html = LITHIUM.TinyMceEditor.emoticonsHtml.html;
                LITHIUM.TinyMceEditor.emoticonsHtml.html = '';
            } catch( e ){}

            var message = $( 'textarea[name="tinyMceEditor"]' ).val();
            var $editor = $( '#main-editor' );
            var $rules  = $('#mobile-house-rules').detach()

            $('.lia-form-submit.lia-button-group').append($rules)

            $( '.MessageEditor' ).find( '.lia-quilt-row.lia-quilt-row-standard' ).prepend( $( '.reply-editor' ).detach() );
            $editor.val( message );
            $editor.EditorPDC();

            $oldLabels.val( '' );
            LITHIUM.jQuery( '.predefined-labels' ).find( 'li:first-child' ).children().trigger( 'click' );
            $currentSubject.attr( 'placeholder', l10n.compose_page.subject_placeholder ).after( $subjectLoader );

            var DOMSubtreeModifiedDone = true;

            $( '.message-preview' ).bind( 'DOMSubtreeModified', function( e )
            {

                if( $( this ).find( '.lia-message-view' ).size() > 0 )
                {
                    var IE    = (!! window.ActiveXObject && +(/msie\s(\d+)/i.exec(navigator.userAgent)[1])) || NaN
                      , delay = 500;

                    if( IE < 9 )
                    {
                        delay = 0;
                    }

                    if( !previewing )
                    {
                        return;
                    }

                    if( !DOMSubtreeModifiedDone )
                    {
                        return;
                    }

                    DOMSubtreeModifiedDone = false;


                    // adding 1 second delay to avoid a flashing loader
                    setTimeout( function()
                    {
                        loading( false, '#preview-post-loader' );
                        $( '.lia-tabs-standard' ).find( '.preview-tab' ).removeClass( 'lia-tabs-inactive' ).addClass( 'lia-tabs-active' ).siblings().removeClass( 'lia-tabs-active' ).addClass( 'lia-tabs-inactive' );
                        LITHIUM.jQuery( '.message-preview' ).show();
                        LITHIUM.jQuery( '.message-body-editor' ).hideOffScreen();
                        DOMSubtreeModifiedDone = true;
                    }, delay );
                }
            } );

            $( '.rich-tab a, .html-tab a' ).click( function()
            {
                previewing = false;
            } );
        } );

        var validation = function()
        {
            var errors = false
              , reply  = false
              , edit   = false;

            if( $mainContainer.hasClass( 'thread-compose-reply' ) )
            {
                reply = true;
            }

            if( $mainContainer.hasClass( 'thread-compose-edit' ) )
            {
                edit = true;
            }

            if( $boardsList.hasClass( 'no-category' ) && !reply && !edit )
            {
                errors = true;
                $lithiumCategory.addClass( err ).find( 'label.lia-form-label' ).addClass( err );
            }
            else
            {
                $lithiumCategory.removeClass( err ).find( 'label.lia-form-label' ).removeClass( err );
            }

            if( !$currentSubject.val() )
            {
                errors = true;
                $currentSubject.addClass( err ).closest( '.lia-quilt-row-standard' ).prev().find( 'label' ).addClass( err );
            }
            else
            {
                $currentSubject.removeClass( err ).closest( '.lia-quilt-row-standard' ).prev().find( 'label' ).removeClass( err );
            }

            if( !$( '.CM090_inlineTabs_boards' ).find( '.current-tab' ).size() && !reply && !edit  )
            {
                errors = true;
                $boardsList.children( 'h4' ).addClass( err );
            }
            else
            {
                $boardsList.children( 'h4' ).removeClass( err );
            }

            if( $( '.CM090_inlineTabs_labels:not(.hidden)' ).find( 'li' ).size() > 0 && !reply && !getLabels() )
            {
                errors = true;
                $labels.children( 'h4' ).addClass( err );
            }
            else
            {
                $labels.children( 'h4' ).removeClass( err );
            }

            $errors[ errors ? 'removeClass' : 'addClass' ]( 'hide' );

            if( errors )
            {
                $( 'html,body' ).animate( {
                    scrollTop: $errors.offset().top - 130
                }, 400 );
            }

            return !errors;
        };

        var loading = function( status, loader )
        {
            loader = loader || '#adding-post-loader';
            var $loader = $lithiumComposeEditor[ status ? 'addClass' : 'removeClass' ]( 'loading' ).find( loader )[ status ? 'addClass' : 'removeClass' ]( 'visible' );

            $( 'html,body' ).animate( {
                scrollTop : parseInt( $loader.offset().top ) - 350
            }, 400 );
        };

        var startPreview = function()
        {
            if( previewing )
            {
                return;
            }

            loading( true, '#preview-post-loader' );
            LITHIUM.jQuery( '.preview-tab a' ).click();
            //LITHIUM.jQuery( '.lia-button-Preview-action' ).click();
            previewing = true;
        };

        this.layout = function()
        {
            $subjectField.before( $lithiumCategory );
            $( '.lia-form-post-fieldset-toggle' ).after( $boardsList );

            // we don't care about the value of this field: is used only to pass the validation in order to preview the message
            $( 'form.MessageEditorForm' ).append( '<input value="board-id/73" name="t:ac" type="hidden">' );

            $previewClone.appendTo( $mainContainer.find( '.lia-button-wrapper-Cancel-action' ) );

            $previewClone.click( function( e )
            {
                e && e.preventDefault();

                if( $mainContainer.hasClass( 'thread-compose-reply' ) || $mainContainer.hasClass( 'thread-compose-edit' ) )
                {
                    startPreview();
                    //LITHIUM.jQuery( '.lia-tabs.preview-tab' ).find( 'a' ).click();
                    return true;
                }

                if( validation() )
                {
                    startPreview();
                    //LITHIUM.jQuery( '.lia-tabs.preview-tab' ).find( 'a' ).click();
                }
            } );

            $( '.quote-button, .quote a' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                LITHIUM.jQuery( '.quote-message-link' ).trigger( 'click' );

                $( 'html,body' ).animate( {
                    scrollTop: $lithiumComposeEditor.offset().top
                }, 400 );
            } );

            $('.board-select select').on('change', function (e) {
                if (!this.value) {
                    $(this).parent().next().find('.current-tab').children().click()
                } else {
                    $('.board[data-id="' + this.value + '"]').click()
                    $('.label-select select').val('')
                }
            })

            $('.label-select select').on('change', function (e) {
                if (!this.value) {
                    $(this).parent().next().find('.current-tab').children().click()
                } else {
                    $('.label[data-name="' + this.value + '"]').click().parent().siblings().removeClass('current-tab')
                }
            })

            $labelsTabs.on( 'click', '.label', function( e )
            {
                e && e.preventDefault();

                if( $( this ).closest( 'ul' ).find( '.current-tab' ).size() >= 3 && !$( this ).parent().hasClass( 'current-tab' ) )
                {
                    return false;
                }

                $(this).closest('ul').prev('.label-select').children().val($(this).data('name'));
                $( this ).parent().toggleClass( 'current-tab' );

            } );

            $( '.CM090_inlineTabs_boards' ).on( 'click', '.board', function( e )
            {
                e && e.preventDefault();

                var boardId = $( this ).data( 'id' )
                  , $list   = $boardsList.find( '#' + boardId + '-labels-list' );

                $(this).closest('ul').prev('.board-select').children().val(boardId);

                $( this ).parent().addClass( 'current-tab' ).siblings().removeClass( 'current-tab' );
                $( '.CM090_inlineTabs_labels' ).find( '.current-tab' ).removeClass( 'current-tab' );
                $labels[ $list.find( 'li' ).size() ? 'show' : 'hide' ]();
                $list.removeClass( 'hidden' ).siblings( ':not(.hidden):not(h4)' ).addClass( 'hidden' );
            } );

            $availableCategories.on( 'click', 'a', function( e )
            {
                e && e.preventDefault();

                var id = $( this ).data( 'id' );

                if( undefined !== id )
                {
                    $boardsList.show().removeClass( 'no-category' );
                    $currentCategory.text( $( this ).text() );
                    var $list = $boardsList.find( '#' + id + '-board-list' );

                    if( firstExec )
                    {
                        firstExec = false;
                    }
                    else
                    {
                        $labels.hide();
                        $labels.children( 'h4' ).removeClass( 'lia-form-field-error' );

                        $( '.CM090_inlineTabs_boards' ).find( '.current-tab' ).removeClass( 'current-tab' );
                        $( '.CM090_inlineTabs_labels' ).find( '.current-tab' ).removeClass( 'current-tab' );
                    }

                    $list.show().siblings( '.CM090_inlineTabs' ).hide();
                    $availableCategories.addClass( 'hidden' );
                }
            } );

            $currentCategory.on( 'click', function( e )
            {
                e && e.preventDefault();

                $availableCategories.toggleClass( 'hidden' ).find( '.current-tab' ).removeClass( 'current-tab' );
            } );

            $( '.lia-form-auto-subscribe-to-thread-input' ).on( 'change', function( e )
            {
                if( !this.$label )
                {
                    this.$label = $( '.lia-form-auto-subscribe-to-thread-entry' ).find( 'label' );
                }

                this.$label[ this.checked ? 'addClass' : 'removeClass' ]( 'checked' );
            } );

            $document.on( 'mouseup', function( e )
            {
                if( !$availableCategories.is( e.target ) && $availableCategories.has( e.target ).length === 0 )
                {
                    $availableCategories.addClass( 'hidden' );
                }
            } );

            if( $( '.current-category-dropdown' ).size() )
            {
                $( '.current-category-dropdown' ).trigger( 'click' );
            }
        };

        var getLabels = function()
        {
            var l = [];

            $( '.CM090_inlineTabs_labels:not( .hidden )' ).find( '.current-tab' ).each( function()
            {
                l.push( $( this ).children().data( 'name' ) );
            } );

            return l.join( ',' );
        };

        this.submit = function()
        {
            //var prop20 = $.fn.SiteCatalyst.globals.thread.prop20;

            $( '.lia-button-Submit-action' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( validation() )
                {
                    var $replyEditor = $( '#main-editor' ).closest('.reply-editor')
                      , reply    = false
                      , edit     = false
                      , boardId  = $( '.CM090_inlineTabs_boards' ).find( '.current-tab .board' ).data( 'id' )
                      , endpoint = '/playstationeu/restapi/vc/boards/id/' + boardId + '/messages/post'
                      , labels   = getLabels();

                    if ($replyEditor.find('.editing-html').size()) {
                        content = $replyEditor.find('textarea').val();
                    } else {
                        try {
                            content = tinymce.editors['main-editor'].save();
                        } catch (e) {
                            content = $('.lia-form-body-input.lia-form-type-text.lia-form-input-vertical').val()
                        }
                    }

                    var data = {
                        'message.subject'         : $currentSubject.val(),
                        'message.body'            : content,
                        'message.subscribe_type'  : $( '.lia-form-auto-subscribe-to-thread-input' ).is( ':checked' ) ? 'thread' : '',
                        'restapi.response_style'  : 'view',
                        'restapi.response_format' : 'json'
                    };

                    if( $mainContainer.hasClass( 'thread-compose-reply' ) )
                    {
                        endpoint = '/playstationeu/restapi/vc/messages/id/' + $( '#edit-message-current-id' ).data( 'id' ) + '/reply';
                        reply    = true;
                    }
                    else if( $mainContainer.hasClass( 'thread-compose-edit' ) )
                    {
                        endpoint = '/playstationeu/restapi/vc/messages/id/' + $( '#edit-message-current-id' ).data( 'id' ) + '/edit';
                        edit     = true;

                        if( labels )
                        {
                            data[ 'label.labels' ] = labels;
                        }
                    }
                    else
                    {
                        if( labels )
                        {
                            data[ 'label.labels' ] = labels;
                        }
                    }

                    loading( true );

                    $.ajax( {
                        type : 'POST',
                        url  : endpoint,
                        data : data,
                        success : function( results )
                        {
                            if( results.response.status == 'success' )
                            {
                                LITHIUM.jQuery( window ).unbind( 'beforeunload' );

                                var url = results.response.message.view_href.split( '#' )
                                  , key = 'new_message';

                                if( reply )
                                {
                                    key = 'new_reply';
                                }
                                else if( edit )
                                {
                                    key = 'message_edited';
                                }

                                if( key == 'new_message' )
                                {
                                    $.fn.SiteCatalyst( 'track', 'Post new thread', {
                                        type   : $.fn.SiteCatalyst.eventType.other,
                                        vars   : {
                                            prop49 : 'button:create a new thread:null:%pageName%',
                                            eVar49 : 'D=c49'
                                        },
                                        events : [ 66 ]
                                    } );
                                }
                                else if( key == 'new_reply' )
                                {
                                    $.fn.SiteCatalyst( 'track', 'Reply to thread', {
                                        type   : $.fn.SiteCatalyst.eventType.other,
                                        vars   : {
                                            prop49 : 'button:reply to thread:null:%pageName%',
                                            eVar49 : 'D=c49'
                                        },
                                        events : [ 66 ]
                                    } );
                                }

                                $.cookie( key, url[ 1 ], { 'expires' : 352, 'path' : '/', 'domain' : window.location.hostname } );

                                window.location.replace( url[ 0 ] );
                            }
                            else
                            {
                                loading( false );
                                alert( results.response.error.message );
                            }
                        }
                    } );
                }

                return false;
            } );
        };

        $( '.message-author-detail' ).find( '.author-radial-rank' ).each( function()
        {
            var progress = new ProgressBar.Circle( this, {
                duration    : 0,
                strokeWidth : 10,
                color       : "#00a2ff",
                trailColor  : "#5e5e5e"
            } );

            var p = $( this ).data( 'progress' );

            progress.set( p / 100 );
            //progress.setText( p );

            $( this ).data( 'progress-bar', progress );
        } );

        this.layout();
        this.submit();
    };

} )( jQuery );
